import { useEffect, useRef, useCallback } from "react";

const GOLD_COLORS = ["#c6a96f", "#d4b97e", "#a08a58", "#e8d5a3", "#b09030", "#f0e6c8"];

function randomBetween(a, b) {
  return a + Math.random() * (b - a);
}

export default function GoldConfetti({ trigger }) {
  const canvasRef = useRef(null);
  const animRef = useRef(null);
  const lastTrigger = useRef(0);

  const burst = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles = [];
    const count = 80;

    for (let i = 0; i < count; i++) {
      particles.push({
        x: randomBetween(0, canvas.width),
        y: randomBetween(-20, -200),
        w: randomBetween(2, 5),
        h: randomBetween(4, 8),
        color: GOLD_COLORS[Math.floor(Math.random() * GOLD_COLORS.length)],
        speedY: randomBetween(1.5, 4),
        speedX: randomBetween(-1, 1),
        rotation: randomBetween(0, Math.PI * 2),
        rotSpeed: randomBetween(-0.05, 0.05),
        opacity: randomBetween(0.4, 0.9),
        delay: randomBetween(0, 600),
      });
    }

    const start = performance.now();
    const duration = 4000;

    function animate(now) {
      const elapsed = now - start;
      if (elapsed > duration) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        return;
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      for (const p of particles) {
        if (elapsed < p.delay) continue;
        const t = elapsed - p.delay;
        const progress = t / (duration - p.delay);
        const fadeOut = progress > 0.7 ? 1 - (progress - 0.7) / 0.3 : 1;

        p.x += p.speedX;
        p.y += p.speedY;
        p.rotation += p.rotSpeed;

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.globalAlpha = p.opacity * fadeOut;
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }

      animRef.current = requestAnimationFrame(animate);
    }

    if (animRef.current) cancelAnimationFrame(animRef.current);
    animRef.current = requestAnimationFrame(animate);
  }, []);

  useEffect(() => {
    if (trigger > lastTrigger.current) {
      lastTrigger.current = trigger;
      burst();
    }
  }, [trigger, burst]);

  useEffect(() => {
    return () => { if (animRef.current) cancelAnimationFrame(animRef.current); };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        pointerEvents: "none",
        zIndex: 60,
      }}
    />
  );
}
